import {TakipAltTipiEntity} from "@/entity/TakipAltTipiEntity";
import {TakipMahiyetiEntity} from "@/entity/TakipMahiyetiEntity";
import {TakipTipiEntity} from "@/entity/TakipTipiEntity";
import {TakipYoluEntity} from "@/entity/TakipYoluEntity";

export default class DosyaBilgileri {
    takip_tipi!: number;
    takip_alt_tipi !: string;
    takip_yolu !: string;
    // Takip yolu "Diğer" seçildiğinde girilen serbest metin (backend: takip_talepleri.manuel_takip_yolu).
    manuel_takip_yolu?: string;
    takip_tarihi!: string;
    tekil_alan !: number;
    takip_mahiyeti!: string;
    tuketici_kodu!:number
    icra_dairesi!: string;
    esas_no!: string;
    ek_alanlar?: Array<{ isim: string; kod: string; tur: string; deger: string }>;

}